module.exports = __webpack_public_path__ + "static/img/banner3.f1a4144.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner3.png
// module id = XMCP
// module chunks = 1